<ng-template #kaseyaStoreItemContent let-isKaseyaStoreSsoLinkLoading="isLoading" let-navigationItem>
  {{ navigationItem.labelTranslateKey | translate }}

  @if (isKaseyaStoreSsoLinkLoading) {
    <div class="top-navigation-dropdown__spinner">
      <kds-spinner />
    </div>
  } @else {
    <i aria-hidden="true" class="top-navigation-dropdown__icon fa-regular fa-external-link"></i>
  }
</ng-template>

<div class="top-navigation-dropdown">
  @for (navigationItem of navigationItems(); track navigationItem.id) {
    <ng-container *itcFeature="navigationItem.features">
      <ng-container *itcCountryAccess="navigationItem.accessibleCountries">
        @switch (navigationItem.id) {
          @case (TopNavigationPath.KaseyaStore) {
            @let isKaseyaStoreSsoLinkLoading = isKaseyaStoreSsoLinkLoading$ | async;

            @if (isMigratedUser) {
              <button
                *itcPermission="Permission.SalesforceECommerce"
                #dropdownItem
                type="button"
                class="top-navigation-dropdown__item"
                [class.top-navigation-dropdown__item--loading]="isKaseyaStoreSsoLinkLoading"
                [itcOpenSsoSalesforceLink]="SsoSalesforceDestination.Home"
                [isLoading$]="isKaseyaStoreSsoLinkLoading$"
                (click)="closeDropdownWhenLoadingIsDone()"
              >
                <ng-template
                  *ngTemplateOutlet="kaseyaStoreItemContent; context: { $implicit: navigationItem, isLoading: isKaseyaStoreSsoLinkLoading }"
                />
              </button>
            } @else {
              <button
                *itcPermission="navigationItem.permissions"
                #dropdownItem
                type="button"
                class="top-navigation-dropdown__item"
                [class.top-navigation-dropdown__item--loading]="isKaseyaStoreSsoLinkLoading"
                [itcOpenSsoLink]="SsoTargetPage.KaseyaStore"
                [isLoading$]="isKaseyaStoreSsoLinkLoading$"
                (click)="closeDropdownWhenLoadingIsDone()"
              >
                <ng-template
                  *ngTemplateOutlet="kaseyaStoreItemContent; context: { $implicit: navigationItem, isLoading: isKaseyaStoreSsoLinkLoading }"
                />
              </button>
            }
          }
          @default {
            <a
              *itcPermission="navigationItem.permissions"
              #dropdownItem
              class="top-navigation-dropdown__item"
              routerLinkActive="top-navigation-dropdown__item--active"
              ariaCurrentWhenActive="page"
              kdsPrefetch
              [routerLink]="navigationItem.id"
              (click)="isDropdownOpen.set(false)"
            >
              {{ navigationItem.labelTranslateKey | translate }}
            </a>
          }
        }
      </ng-container>
    </ng-container>
  }
</div>
